import { useCart } from "../../../../app/context/cart-context/cart-context";

import './add-to-cart-btn.css';

export const AddToCartBtn = ({productId}) => {

    const {addToCart} = useCart();

    const handleButtonClick = (e, item) => {
        e.preventDefault();
        e.stopPropagation();
        addToCart(item);
    }

    return (
        <button className="add-to-cart-btn" onClick={(e) => handleButtonClick(e, {id: productId, qty: 1})}>
            Додати
        </button>
    )
}